import React from 'react';
import Information from './Information';
import OrderHistory from './OrderHistory';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const EmployeeViewMenu = ({ employeeInfo, orders, loadOrder, changePage, handleTabs, tabValue }) => {
    return (
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 mt-2 text-center">
            <Tabs value={tabValue} onChange={handleTabs} id="Employee-Menu" className="Menu-tabs-viewpage">
                <Tab value="info" label="Information" className={`Tab-div ${tabValue === "info" ? "Mui-selected" : ""}`} onClick={() => handleTabs("info")} />
                <Tab value="history" label="Order History" className={`${tabValue === "history" ? "Mui-selected" : ""}`} onClick={() => {
                    handleTabs("history");
                    loadOrder()
                }} />

            </Tabs>
            {tabValue === "info" && <Information {...employeeInfo} />}
            {tabValue === "history" && <OrderHistory orders={orders.orders} pagination={orders.pagination} changePage={changePage} />}

        </div>
    )
}

export default EmployeeViewMenu;